var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "login-fade" }, [
    _c("div", { staticClass: "login" }, [
      _c(
        "button",
        { staticClass: "login-close", on: { click: _vm.loginClose } },
        [
          _c(
            "svg",
            {
              attrs: {
                width: "23",
                height: "23",
                viewBox: "0 0 23 23",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M2.00342 2L20.6685 20.6651",
                  stroke: "black",
                  "stroke-width": "3",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M20.665 2L1.99993 20.6651",
                  stroke: "black",
                  "stroke-width": "3",
                  "stroke-linecap": "round",
                },
              }),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "login-form" }, [
        _c("p", { staticClass: "login-title" }, [_vm._v("Change Password")]),
        _vm._v(" "),
        _c("p", { staticClass: "login-subtitle" }, [
          _vm._v(
            "\n        We’ll email you a link to reset your password.\n      "
          ),
        ]),
        _vm._v(" "),
        _c(
          "form",
          {
            attrs: { id: "login" },
            on: {
              submit: function ($event) {
                return _vm.submitForm($event)
              },
            },
          },
          [
            _c("div", { staticClass: "input-wrapper" }, [
              _c(
                "svg",
                {
                  staticClass: "input-icon",
                  attrs: {
                    width: "15",
                    height: "12",
                    viewBox: "0 0 16 12",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d: "M1.4615 12H14.5392C15.3452 12 15.9998 11.3628 16 10.581V1.41793C16 0.635655 15.3452 0 14.5394 0H1.4615C0.654828 0 0 0.635655 0 1.41793V10.581C0 11.3628 0.654828 12 1.4615 12ZM1.4615 1.42811L14.5277 1.41811H14.5278V10.5717L1.47145 10.5812L1.4615 1.42811Z",
                      fill: "#6F96D7",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M7.99907 8C7.83687 8 7.67467 7.94124 7.54241 7.82567L1.25092 2.30059C0.952869 2.03722 0.9142 1.57316 1.16794 1.26278C1.41997 0.950436 1.86602 0.910904 2.16493 1.17445L7.99924 6.29993L13.8344 1.17445C14.1343 0.911082 14.5795 0.950436 14.8324 1.26278C15.0853 1.57316 15.0475 2.03722 14.7493 2.30059L8.45556 7.82567C8.32347 7.94124 8.16127 8 7.99907 8Z",
                      fill: "#6F96D7",
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.email,
                    expression: "email",
                  },
                ],
                staticClass: "input",
                attrs: { type: "text", placeholder: "Email" },
                domProps: { value: _vm.email },
                on: {
                  input: [
                    function ($event) {
                      if ($event.target.composing) return
                      _vm.email = $event.target.value
                    },
                    function ($event) {
                      return _vm.validateForm()
                    },
                  ],
                },
              }),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "login-submit",
                attrs: {
                  type: "submit",
                  disabled: !_vm.isValid && !_vm.autofilled,
                },
                on: {
                  click: function ($event) {
                    return _vm.submitForm($event)
                  },
                },
              },
              [_vm._v("\n          Send\n        ")]
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }